import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`qualityApplicationNew/findAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`qualityApplicationNew/save`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  delete({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`qualityApplicationNew/delete`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

}
